import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    TablePaginationPadrao,
    rowPertentePage,
    setPageInclusao,
    setPageExclusao,
} from '../../../business-components/Pagination/Pagination'

import {
    TextValidatorText,
    TextValidatorValor,
    TextValidatorValorRequired,
    TextValidatorTextMultiline,
    TextValidatorMesAnoRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelect,
    TextFieldTextSelectRequired,
    TextFieldNumberSelect,
    TextFieldNumberSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import tipoDiaDiaList from '../../../business-rules/List/tipoDiaDiaList'

//import parentescoList from '../../../business-rules/List/parentescoList'

import tipoPeriodicidadeList from '../../../business-rules/List/tipoPeriodicidadeList'

import tipoFormaPagtoList from '../../../business-rules/List/tipoFormaPagtoList'

import titularList from '../../../business-rules/List/titularList'

import tipoGrupoDespesaList from '../../../business-rules/List/tipoGrupoDespesaList'

import {
    IconButtonClearEntradaDados,
    IconButtonHelp,
} from '../../../business-components/IconButton/IconButton'

import {
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    tipoRecursoFinanceiroOrigemRealocacaoCarteiraInvestimentosList,
} from '../garantias-form/GarantiasServiceRecursosFinanceiros'

import {
    processaAlteracaoDiaDiaTipoDiaDia,
    processaAlteracaoDiaDiaTipoPeriodicidadePagto,
    processaAlteracaoDiaDiaValor,
    processaAlteracaoDiaDiaAlterarPeriodoDiaDia,
    processaAlteracaoDiaDiaMesAnoInicial,
    processaAlteracaoDiaDiaMesAnoFinal,
    processaAlteracaoDiaDiaValorCompra,
    processaAlteracaoDescricaoGrupoDespesaOutras,
} from './DespesasServiceDiaDia'


export const TablePaginationPadraoDiaDia = ({ values, setFieldValue }) => {

    return (
        <TablePaginationPadrao
            setFieldValue={setFieldValue}
            list={values.diaDiaPagination}
            nameRowsPerPage={'rowsPerPageDiaDia'}
            namePage={'pageDiaDia'}
            rowsPerPage={values.rowsPerPageDiaDia}
            page={values.pageDiaDia}
        />
    )
}

export const rowPertentePageDiaDia = (values, indAux) => {
    
    return rowPertentePage(indAux, values.pageDiaDia, values.rowsPerPageDiaDia)
}

export const setPageInclusaoDiaDia = (values, setFieldValue) => {

    return setPageInclusao(setFieldValue, 'pageDiaDia', values.diaDiaPagination, values.rowsPerPageDiaDia)
}



export const Familiar = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelect
            name={`diaDia[${ind}].familiar`}
            label={LABEL.familiar}
            value={item.familiar || ''}
            onChange={handleChange}
            list={values.totalDiaDia}
            disabled={item.planejamentoEspecializacaoPeriodoSabatico || expandiu}
        />
    )
}

export const TipoDiaDia = ({ TextFieldNumberSelectTipoDiaDia, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldNumberSelectTipoDiaDia
            name={`diaDia[${ind}].tipoDiaDia`}
            placeholder={LABEL.tipoDiaDia}
            value={item.tipoDiaDia || ''}
            onChange={handleChange}
            list={tipoDiaDiaList}
            onBlur={processaAlteracaoDiaDiaTipoDiaDia(item)}
            disabled={item.planejamentoEspecializacaoPeriodoSabatico || expandiu}
        />
    )
}

export const IconButtonClearEntradaDadosDiaDia = ({ values, setFieldValue, item, ind, arrayHelpers, simplificado }) => {

    return (
        !item.idPergunta && !simplificado && !item.planejamentoEspecializacaoPeriodoSabatico
            ?
                <IconButtonClearEntradaDados
                    onClick={() => {
                        arrayHelpers.remove(ind)
                        setPageExclusao(setFieldValue, 'pageDiaDia', values.diaDiaPagination, values.rowsPerPageDiaDia, values.pageDiaDia)
                    }}
                />
            :
                ''
    )
}

export const Valor = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorValorRequired
            name={`diaDia[${ind}].valor`}
            label={LABEL.valorDespesa}
            value={item.valor || ''}
            onChange={handleChange}
            onBlur={processaAlteracaoDiaDiaValor(values, item)}
            disabled={item.planejamentoEspecializacaoPeriodoSabatico || expandiu}
        />
    )
}

export const ValorNaAposentadoria = ({ item, ind, handleChange/*, labelCurto*/, expandiu }) => {

    return (
        <TextValidatorValor
            name={`diaDia[${ind}].valorNaAposentadoria`}
            label={LABEL.valorNaAposentadoria}
            //label={labelCurto ? LABEL.valorNaAposentadoriaCurto : LABEL.valorNaAposentadoria}
            value={item.valorNaAposentadoria || ''}
            onChange={handleChange}
            disabled={expandiu}
        />
    )
}

export const HelpValorNaAposentadoria = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.valorNaAposentadoria}
            helpText={HELPTEXT.valorNaAposentadoria}
        />
    )
}

//export const ParentescoDependente = ({ item, ind, handleChange }) => {
//
//    return (
//        <TextFieldTextSelectRequired
//            name={`diaDia[${ind}].parentescoDependente`}
//            label={LABEL.parentescoDependente}
//            value={item.parentescoDependente || ''}
//            onChange={handleChange}
//            list={parentescoList(false)}
//        />
//    )
//}

export const TipoPeriodicidadePagto = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextFieldTextSelectRequired
            name={`diaDia[${ind}].tipoPeriodicidadePagto`}
            label={LABEL.tipoPeriodicidadePagto}
            value={item.tipoPeriodicidadePagto || ''}
            onChange={handleChange}
            list={tipoPeriodicidadeList(false, true, true)}
            onBlur={processaAlteracaoDiaDiaTipoPeriodicidadePagto(values, item)}
            disabled={item.idPergunta > 0 || item.planejamentoEspecializacaoPeriodoSabatico || expandiu}
        />
    )
}

export const TipoFormaPagto = ({ item, ind, handleChange, jsonConfiguracao }) => {

    return (
        <TextFieldTextSelectRequired
            name={`diaDia[${ind}].tipoFormaPagto`}
            label={LABEL.tipoFormaPagto}
            value={item.tipoFormaPagto || ''}
            onChange={handleChange}
            list={tipoFormaPagtoList(jsonConfiguracao)}
            desejavel={true}
        />
    )
}

export const DespesaPessoal = ({ values, item, ind, handleChange, labelCurto }) => {

    return (
        <CheckboxPadrao
            name={`diaDia[${ind}].despesaPessoal`}
            label={
                (labelCurto
                    ?
                        LABEL.despesaPessoalCurto
                    :
                        LABEL.despesaPessoal + " " +
                            (item.familiar === HARDCODE.idFamiliarCliente
                                ?
                                    tituloCliente(values)
                                :
                                    tituloConjuge(values)
                            )
                )
            }
            checked={item.despesaPessoal}
            onChange={handleChange}
        />
    )
}

export const HelpDespesaPessoal = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.despesaPessoal}
            helpText={HELPTEXT.despesaPessoal}
        />
    )
}

export const ConsumirRecursosFinanceirosEmVezDaReceitaMensal = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`diaDia[${ind}].consumirRecursosFinanceirosEmVezDaReceitaMensal`}
            label={LABEL.consumirRecursosFinanceirosEmVezDaReceitaMensal}
            checked={item.consumirRecursosFinanceirosEmVezDaReceitaMensal}
            onChange={handleChange}
            disabled={item.planejamentoEspecializacaoPeriodoSabatico}
        />
    )
}

export const HelpConsumirRecursosFinanceirosEmVezDaReceitaMensal = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.consumirRecursosFinanceirosEmVezDaReceitaMensal}
            helpText={HELPTEXT.consumirRecursosFinanceirosEmVezDaReceitaMensalDiaDia}
        />
    )
}

export const RecursoFinanceiroConsumirRecursosFinanceirosEmVezDaReceitaMensal = ({ values, item, ind, handleChange }) => {

    return (
        <TextFieldNumberSelect
            name={`diaDia[${ind}].idRecursoFinanceiroConsumirRecursosFinanceirosEmVezDaReceitaMensal`}
            label={LABEL.idRecursoFinanceiroConsumirRecursosFinanceirosEmVezDaReceitaMensal}
            value={item.idRecursoFinanceiroConsumirRecursosFinanceirosEmVezDaReceitaMensal || ''}
            onChange={handleChange}
            list={tipoRecursoFinanceiroOrigemRealocacaoCarteiraInvestimentosList(values, {})}
        />
    )
}

export const PeriodoDiaDia = () => {

    return (
        <>
            <span
                className='text-muted'
            >
                {LABEL.periodoDiaDia + ": "}
            </span>
            <span>
                {LABEL.vitalicio}
            </span>
        </>
    )
}

export const AlterarPeriodoDiaDia = ({ values, item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`diaDia[${ind}].alterarPeriodoDiaDia`}
            label={LABEL.alterarPeriodoDiaDia}
            checked={item.alterarPeriodoDiaDia}
            onChange={handleChange}
            onBlur={
                processaAlteracaoDiaDiaAlterarPeriodoDiaDia(item, values)
            }
            disabled={
                item.planejamentoEspecializacaoPeriodoSabatico // ||
                //item.tipoPeriodicidadePagto === HARDCODE.idTipoPeriodicidadeUnica
            }
        />
    )
}

export const MesAnoInicial = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorMesAnoRequired
            name={`diaDia[${ind}].mesAnoInicial`}
            label={LABEL.mesAnoInicial}
            value={item.mesAnoInicial || ''}
            onChange={handleChange}
            onBlur={processaAlteracaoDiaDiaMesAnoInicial(values, item)}
            disabled={item.planejamentoEspecializacaoPeriodoSabatico || expandiu}
        />
    )
}

export const MesAnoFinal = ({ values, item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorMesAnoRequired
            name={`diaDia[${ind}].mesAnoFinal`}
            label={LABEL.mesAnoFinal}
            value={item.mesAnoFinal || ''}
            onChange={handleChange}
            onBlur={processaAlteracaoDiaDiaMesAnoFinal(values, item)}
            disabled={item.planejamentoEspecializacaoPeriodoSabatico || expandiu}
        />
    )
}

export const DiaDiaIraOcorrerAteExpectativaVida = ({ item, ind, handleChange }) => {

    return (
        <CheckboxPadrao
            name={`diaDia[${ind}].diaDiaIraOcorrerAteExpectativaVida`}
            label={LABEL.diaDiaIraOcorrerAteExpectativaVida}
            checked={item.diaDiaIraOcorrerAteExpectativaVida}
            onChange={handleChange}
        />
    )
}

export const ValorAcumulado = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`diaDia[${ind}].valorAcumulado`}
            label={LABEL.valorAcumulado}
            value={item.valorAcumulado || ''}
            onChange={handleChange}
            disabled={true}
        />
    )
}

export const ValorCompra = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`diaDia[${ind}].valorCompra`}
            label={LABEL.valorCompra}
            value={item.valorCompra || ''}
            onChange={handleChange}
            onBlur={processaAlteracaoDiaDiaValorCompra(item)}
        />
    )
}

export const TitularRespValorCompra = ({ values, item, ind, handleChange }) => {

    return (
        <TextFieldTextSelect
            name={`diaDia[${ind}].titularRespValorCompra`}
            label={LABEL.titularRespValorCompra}
            value={item.titularRespValorCompra || ''}
            onChange={handleChange}
            list={titularList(values, 'simples')}
        />
    )
}

export const DescricaoDiversasOutros = ({ item, ind, handleChange, expandiu }) => {

    return (
        <TextValidatorText
            name={`diaDia[${ind}].descricaoDiversasOutros`}
            label={LABEL.descricao}
            value={item.descricaoDiversasOutros || ''}
            onChange={handleChange}
            tamMax={TAMMAX.descricaoDiaDiaDiversasOutros}
            notToUpperCase={true}
            disabled={expandiu}
        />
    )
}

export const HelpDescricaoDiversasOutros = () => {
    
    return (
        <IconButtonHelp
            helpTitle={LABEL.descricao}
            helpText={HELPTEXT.descricaoDiaDiaDiversasOutros}
        />
    )
}

export const GrupoDespesa = ({ item, ind, handleChange }) => {

    return (
        <TextFieldNumberSelectRequired
            name={`diaDia[${ind}].grupoDespesa`}
            label={LABEL.grupoDespesa}
            value={item.grupoDespesa || ''}
            onChange={handleChange}
            list={tipoGrupoDespesaList}
            onBlur={processaAlteracaoDescricaoGrupoDespesaOutras(item)}
        />
    )
}

export const DescricaoGrupoDespesaOutras = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorText
            name={`diaDia[${ind}].descricaoGrupoDespesaOutras`}
            label={LABEL.descricaoGrupoDespesaOutras}
            value={item.descricaoGrupoDespesaOutras || ''}
            onChange={handleChange}
            tamMax={TAMMAX.descricaoGrupoDespesaOutras}
            notToUpperCase={true}
        />
    )
}

export const Observacao = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorTextMultiline
            name={`diaDia[${ind}].observacao`}
            label={LABEL.observacao}
            value={item.observacao || ''}
            onChange={handleChange}
            tamMax={TAMMAX.observacao}
        />
    )
}